import clsx from 'clsx';

import '@hotmart/cosmos/dist/loading';

type LoadingProps = {
  full?: boolean;
  text?: string;
};

const Loading = ({ full = false, text = '' }: LoadingProps) => {
  const loadingClassName = clsx({
    '_w-full _h-full _d-flex _align-items-center _justify-content-center': full
  });
  return (
    <div data-test="hot-loading" className={loadingClassName}>
      <hot-loading>{text}</hot-loading>
    </div>
  );
};

export default Loading;
